import React from 'react'

import { AutoSizer, Table, Column } from 'react-virtualized'

import * as css from './TablaReportes.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class TablaReportes extends React.Component{
    render() {
        return (
            <div style={{height: '150px', marginLeft: '-10px', marginRight: '-10px'}}>
                <AutoSizer>
                    {({ height, width }) =>
                        <Table
                            height={height}
                            width={width}
                            headerHeight={0}
                            headerClassName={css.headerColumn}
                            rowCount={this.props.reportes.length}
                            rowGetter={({index}) => this.props.reportes[index]}
                            rowHeight={40}
                            rowClassName={({index})=> index<0? css.headerRow : ((index%2===0)? css.evenRow : css.oddRow )}
                        >
                            <Column
                                dataKey='idMarca'
                                label={''}
                                disableSort={true}
                                cellRenderer={({ rowData, dataKey }) => rowData['tipo']==1? 
                                                                            <div>
                                                                                <div className={cx("col-md-12 col-sm-12", 'div-reportes')}>
                                                                                    <label className={cx("col-md-4 col-sm-4 control-label", 'label-top')}>Hora: {rowData['hora']}</label>
                                                                                    <label className={cx("col-md-4 col-sm-4 control-label", 'label-top')}>Dotación: {rowData['dotacion']}</label>
                                                                                </div>                                                                               
                                                                            </div>
                                                                            :
                                                                            <div>
                                                                                <div className={cx("col-md-12 col-sm-12", 'div-reportes')}>
                                                                                    <label className={cx("col-md-3 col-sm-2 control-label", 'label-top')}>Hr:{rowData['hora']}</label>
                                                                                    <label className={cx("col-md-3 col-sm-2 control-label", 'label-top')}>Avance: {rowData['avance']}%</label>
                                                                                    <label className={cx("col-md-3 col-sm-2 control-label", 'label-top')}>Aud.: {rowData['auditoria']}%</label>
                                                                                    <label className={cx("col-md-3 col-sm-2 control-label", 'label-top')}>Err: {rowData['error']}%</label>
                                                                                </div>                                                                              
                                                                            </div>
                                                                            }
                                width={width}
                            />
                        </Table>
                    }
                </AutoSizer>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/api/reportes/TablaReportes.jsx